import React, { useContext, useEffect, useState } from "react";
import { Team } from "../../models";
import BasicSelect, {formattedOption} from "../Select/BasicSelect";
import { IonLabel, isPlatform } from "@ionic/react";
import { isWindows } from "../../utilities/platform/Platform";
import RequiredInputIndicator from "../Forms/RequiredInputIndicator";
import moment from "moment";
import ErrorAlert from "../Errors/ErrorAlert";
import { getAllCurrentTeams } from "../../utilities/team/TeamUtils";
import { PersonContext } from "../../context/PersonContext";

interface _Props {
    isDisabled?: boolean
    menuPlacement?: (string | null)
    hideLabel?: boolean
    label?: string
    teamsToChooseFrom?: (Team[] | null)
    selectedValue?: (string | null)
    onSelect: Function
}

const SelectTeam: React.FC<_Props> = ({isDisabled, hideLabel, label, selectedValue, teamsToChooseFrom, menuPlacement, onSelect}) => {
    const user = useContext(PersonContext);

    const [selected, setSelected] = useState<string | null | undefined>();
    const [formattedTeams, setFormattedTeams] = useState<formattedOption[] | null | undefined>();
    const [error, setError] = useState("");

    useEffect(() => {
        const getTeams = async () => {
            setError("");
            const teams = await getAllCurrentTeams();
            if (teams && teams.length > 0) {
                formatTeams(teams);
            } else {
                setError("Sorry, no teams were found. Please contact hello@ringsidepro.com for assistance.");
            }
        }
    
        const formatTeams = (teams: Team[]) => {
            setError("");
            let formattedTeams = [];
            for (var i = 0; i < teams.length; i++) {
                const team = teams[i];
                const value = team.id;
                const label = team.name + (team.createdOn ? (" (created: " + moment(team.createdOn).format("MM/YYYY") + ")") : "");
                let object: formattedOption = {
                    value: value,
                    label: label,
                    object: teams[i]
                };
                formattedTeams.push(object);
            }
            setFormattedTeams(formattedTeams);
        }
    
        if (teamsToChooseFrom) {
            setError("");
            formatTeams(teamsToChooseFrom);
        }
        else {
            getTeams();
        }
    }, [teamsToChooseFrom]);

    useEffect(() => {
        if (selectedValue) setSelected(selectedValue);
        else setSelected("");
    }, [selectedValue]);

    const handleOnChange = (team?: any) => {
        if (team) {
            onSelect(team);
        } else {
            onSelect();
        }
    }

    return (
        <>
            {error && <ErrorAlert error={error} width="12" />}
            {!(!!hideLabel) && (
                <IonLabel position={isWindows() || isPlatform("desktop") ? "floating" : "stacked"} className="ion-text-wrap">{label || "Select Team"} <RequiredInputIndicator/></IonLabel>
            )}
            {formattedTeams ?
                <BasicSelect formattedValues={formattedTeams} menuPlacement={menuPlacement} selectedValue={selected} isClearable={false} isDisabled={isDisabled} onSelect={handleOnChange} />
                :
                <p>Loading options...</p>
            }
        </>
    )
};

export default SelectTeam;